import { useEffect, useState } from "react";
import { ReportInfo, ReportProps, ReportUI } from "../../../../types/types";
import "./../ReportCreationFormPages.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import { ArrayUtils } from "../../../../utils/arrayUtils";
import { Text } from "@mantine/core";
import { X } from "tabler-icons-react";
import { popNotification } from "../../../kpi/setup/notification/notificationUtils";
import { useAuth } from "../../../../providers/AuthProvider";
import { getRoles, getUserList } from "../../../../services/reportService";
import { LoadingOverlay } from "@mantine/core";
import { GlobalFilter } from "./GlobalFilter/GlobalFilter";

export function ReportGlobalFilterFormPage(props: ReportProps) {

    const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
    const reportUI = props.reportUI;

    const [roles, setRoles] = useState([
        { value: " ", label: "Select Role Name" },
    ]);

    const types: any = [
        { value: " ", label: "Select Report Type" },
        { value: "master", label: "Master" },
        { value: "transaction", label: "Transaction" },
    ];
    const [role, setRole] = useState(
        reportUI.role == null ? " " : reportUI.role
    );

    const [type, setType] = useState(
        reportUI.role == null ? " " : reportUI.type
    );

    const [label, setLabel] = useState(
        reportUI.label == null ? "" : reportUI.label
    );
    const [dateFilter, setDateFilter] = useState(
        reportUI.filter == null ? " " : reportUI.filter
    );

    const [show, setShow] = useState(props.showReport);

    const roleError =
        ArrayUtils.isNotEmpty(props.validationErrors) &&
        props.validationErrors
            .filter((error) => error.property === "roleError")
            .map((error) => error.message)[0];

    const typeError =
        ArrayUtils.isNotEmpty(props.validationErrors) &&
        props.validationErrors
            .filter((error) => error.property === "typeError")
            .map((error) => error.message)[0];

    const labelError =
        ArrayUtils.isNotEmpty(props.validationErrors) &&
        props.validationErrors
            .filter((error) => error.property === "labelError")
            .map((error) => error.message)[0];


    const viewOnlyNotifucation = () => {
        if (props.reportInfo.viewEditStatus === "VIEW" ? true : false)
            popNotification("Oops!", "You are in View Mode", "blue", <X />);
    };

    const addReportRole = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setRole(event.target.value);
        props.setReportUI({
            ...props.reportUI,
            role: event.target.value as string
        } as ReportUI);
        props.setReportState((currentState) => ({
            ...currentState,
            validationErrors: currentState.validationErrors.filter(
                (er) => er.property !== "role"
            ),
        }));
    };

    const addReportType = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setType(event.target.value);
        props.setReportUI({
            ...props.reportUI,
            type: event.target.value as string
        } as ReportUI);
        props.setReportState((currentState) => ({
            ...currentState,
            validationErrors: currentState.validationErrors.filter(
                (er) => er.property !== "type"
            ),
        }));
    };

    const addReportLabel = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setLabel(event.target.value);
        props.setReportUI({
            ...props.reportUI,
            label: event.target.value as string
        } as ReportUI);
        props.setReportState((currentState) => ({
            ...currentState,
            validationErrors: currentState.validationErrors.filter(
                (er) => er.property !== "label"
            ),
        }));
    };

    const addDateFilter = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setDateFilter(event.target.value);
        props.setReportUI({
            ...props.reportUI,
            filter: event.target.value as string
        } as ReportUI);
        props.setReportState((currentState) => ({
            ...currentState,
            validationErrors: currentState.validationErrors.filter(
                (er) => er.property !== "dateFilter"
            ),
        }));
    };

    useEffect(() => {
        getRoles(authContext).then((data) => {
            let divisions = data.features.map((user: any) => {
                let division : any = {};
                if (user.displayName) {
                    division["label"] = user.displayName;
                } else {
                    division["label"] = user.divisionName;
                }
                division["value"] = user.divisionName;
                return division;
            });
            setRoles([{ value: " ", label: "Select Role Name" }, ...divisions]);
        });
    }, []);

    const handleChangeshowInput = (event: any) => {
        setShow(event.target.value === "yes");
        props.setShowReport(event.target.value === "yes")
    };

    return (
        <div
            className="form-group-report wizard-content-card"
            style={{ height: "100%" }}
        >

            <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                    Do You want Report in portal ?
                </FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    className="radiogp"
                    onChange={handleChangeshowInput}
                    id="showFilter"
                    defaultValue={show ? "yes" : "no"}
                >
                    <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="YES"
                        disabled={
                            props.reportInfo.viewEditStatus === "VIEW" ? true : false
                        }
                    />
                    <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="NO"
                        disabled={
                            props.reportInfo.viewEditStatus === "VIEW" ? true : false
                        }
                    />
                </RadioGroup>
            </FormControl>

            {show ? (

             <div>

                <div className="full-width">
                    <div className="input-div">
                        <TextField
                            id="role"
                            select
                            label="Role:"
                            value={role}
                            onChange={addReportRole}
                            sx={{ m: 1, width: "75%" }}
                            SelectProps={{
                                readOnly:
                                    props.reportInfo.viewEditStatus === "VIEW" ? true : false,
                                native: false,
                            }}
                            placeholder="Select Role Name"
                            onFocus={viewOnlyNotifucation}
                            helperText="Select Role Name"
                        >
                            {roles.map((option: any) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>

                        {roleError && <Text color="red">{roleError}</Text>}
                        

                        
                            <TextField
                                id="type"
                                select
                                label="Type:"
                                value={type}
                                onChange={addReportType}
                                sx={{ m: 1, width: "75%" }}
                                SelectProps={{
                                    readOnly:
                                        props.reportInfo.viewEditStatus === "VIEW" ? true : false,
                                    native: false,
                                }}
                                placeholder="Select Report Type"
                                onFocus={viewOnlyNotifucation}
                                helperText="Select Report Type"
                            >
                                {types.map((option: any) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>

                            {typeError && <Text color="red">{typeError}</Text>}
                        

                        
                            <TextField
                                label="Report Name:"
                                onChange={addReportLabel}
                                value={label}
                                id="report_name"
                                placeholder="Enter Report Name"
                                sx={{ m: 1, width: "75%" }}
                                onFocus={viewOnlyNotifucation}
                                InputProps={{
                                    readOnly:
                                        props.reportInfo.viewEditStatus === "VIEW" ? true : false,
                                    startAdornment: (
                                        <InputAdornment position="start"></InputAdornment>
                                    ),
                                }}
                            />
                            {labelError && <Text color="red">{labelError}</Text>}

                            <TextField
                                id="datefilter"
                                select
                                label="DateFilter:"
                                value={dateFilter}
                                onChange={addDateFilter}
                                sx={{ m: 1, width: "75%" }}
                                SelectProps={{
                                    readOnly:
                                        props.reportInfo.viewEditStatus === "VIEW" ? true : false,
                                    native: false,
                                }}
                                placeholder="Select Date Filter"
                                onFocus={viewOnlyNotifucation}
                                helperText="Select Date Filter"
                            >
                                {[{ value: " ", label: "Select Date Filter" },
                                    { value: "date", label: "Date" },
                                    { value: "daterange", label: "Daterange" },
                                    { value: "monthyear", label: "Month-Year" }
                                ].map((option: any) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>

                            {roleError && <Text color="red">{roleError}</Text>}

                            <div><h3>Filters</h3></div>

                            <div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        width: "100%",
                                        height: "100%",
                                        gap: "6%",
                                    }}
                                >
                                    
                                        <LoadingOverlay
                                            visible={false}
                                            style={{ position: "fixed" }}
                                        />
                                    
                                    <GlobalFilter { ...props } />
                                </div>

                            </div>
                        </div>
                    </div>


             </div>

             ): null}
        
        </div>
        );
}
